/** French bar-graph prompts and chart category vocabulary (ADR 0051 part 3). */
export const barGraphPrompts = {
    total: () => `Quel est le total de toutes les barres additionnées ?`,
    largest: () => `Quelle catégorie a le plus grand nombre ?`,
    // Not "... a-t-il ...": the categories are drawn from mixed-gender
    // vocabularies (colours are masculine, most fruit are feminine), so a
    // pronoun tied to whichever one is drawn would need to track its gender.
    // "est-ce que" needs no agreement at all - same fix as the word-problem
    // and elapsed-time templates use for names of unknown gender.
    difference: (larger: string, smaller: string) =>
        `Combien est-ce que ${larger} a de plus que ${smaller} ?`,
    readOne: (label: string) => `Que montre le graphique pour ${label} ?`,
};

export const barGraphLabelSets: { labels: string[]; sequential: boolean }[] = [
    { labels: ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'juil', 'août', 'sep', 'oct', 'nov', 'déc'], sequential: true },
    { labels: ['lun', 'mar', 'mer', 'jeu', 'ven', 'sam', 'dim'], sequential: true },
    { labels: ['Rouge', 'Bleu', 'Vert', 'Jaune', 'Violet', 'Orange'], sequential: false },
    { labels: ['Poire', 'Prune', 'Kiwi', 'Figue', 'Mangue', 'Raisin'], sequential: false },
    { labels: ['Golf', 'Échecs', 'Athlétisme', 'Natation', 'Tennis', 'Patinage'], sequential: false },
];
